/**
 * StatusTag — Figma 387:5493 TagRoundFill
 *
 * 8개 상태 (pending/pickedup/visiting/pos/finishedMaking/preparing/rejected/paid)를
 * Figma 디자인 그대로 렌더링하는 공용 컴포넌트.
 *
 * 사용:
 *   <StatusTag state="pending" />
 *   <StatusTag state="visiting" hide={['visiting', 'pos']} />  // 처방전 관리 탭
 */
import { STATUS_TAG_DEFS } from '../../../constants/statusTags';

export default function StatusTag({ state, hide }) {
  // 숨김 처리 (처방전 관리 탭에서 visiting/pos)
  if (hide && hide.includes(state)) return null;

  const def = STATUS_TAG_DEFS[state];
  if (!def) return null;

  return (
    <span
      className="inline-flex items-center justify-center rounded-2xl border whitespace-nowrap"
      style={{
        height: 22,
        padding: '2px 8px',
        background: def.bg,
        borderColor: def.border,
        color: def.color,
        fontSize: 'var(--text-12)',
        lineHeight: '18px',
        fontWeight: def.weight,
      }}
    >
      {def.label}
    </span>
  );
}
